// Module
var code = "<template> <compose containerless view.bind=\"viewStrategy\"></compose> </template> ";
// Exports
export default code;